module.exports = __webpack_public_path__ + "img/index-3-pic03@2x.9ffc4f9f.png";